import { IProductPages } from 'global';
import { GetStaticProps, NextPage } from 'next';
import { fetchContentfulByHandle } from '../connectors/contentful';
import Landingpage from '../modules/landingpage/home';
import withFallback from '../utils/with-fallback';

const Home: NextPage<{
  contentfulData: IProductPages;
}> = ({ contentfulData }) => <Landingpage contentfulData={contentfulData} />;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const contentfulHandle = `home`;
  const startTime = Date.now();

  console.log(
    `[Performance] Starting getStaticProps for handle: ${contentfulHandle}, locale: ${locale}`
  );
  console.time(`getStaticProps-${contentfulHandle}-${locale}`);

  try {
    console.log(
      `[Performance] Starting Contentful fetch for handle: ${contentfulHandle}`
    );
    console.time(`contentful-fetch-${contentfulHandle}-${locale}`);

    const contentfulData = await fetchContentfulByHandle({
      handle: contentfulHandle,
      locale,
    });

    console.timeEnd(`contentful-fetch-${contentfulHandle}-${locale}`);
    const contentfulFetchTime = Date.now() - startTime;
    console.log(
      `[Performance] Contentful fetch completed in ${contentfulFetchTime}ms`
    );

    if (contentfulData === null) {
      console.log(
        `[Performance] No data found for handle: ${contentfulHandle}`
      );
      console.timeEnd(`getStaticProps-${contentfulHandle}-${locale}`);
      return { notFound: true, revalidate: true };
    }

    const totalTime = Date.now() - startTime;
    console.log(
      `[Performance] getStaticProps completed successfully in ${totalTime}ms`
    );
    console.timeEnd(`getStaticProps-${contentfulHandle}-${locale}`);

    return {
      props: {
        contentfulData,
      },
      revalidate: 600, // 10 minutes
    };
  } catch (error) {
    const errorTime = Date.now() - startTime;
    console.error(
      `[Performance] Error in getStaticProps after ${errorTime}ms for page: ${contentfulHandle}`,
      error
    );
    console.timeEnd(`getStaticProps-${contentfulHandle}-${locale}`);
    return { notFound: true, revalidate: true };
  }
};

export default withFallback(Home);
